import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-comparator',
  templateUrl: './comparator.component.html',
  styleUrls: ['./comparator.component.scss']
})
export class ComparatorComponent implements OnInit {

  public isloggedIn: boolean;
  public title: string = "Autoritatea Nationala de Reglementare in Domeniul Energiei";

  constructor(
    private keycloakService: KeycloakService,
    private route: ActivatedRoute
  ) {
    this.keycloakService.isLoggedIn().then((result: boolean) => (this.isloggedIn = result));
    this.route.queryParams.subscribe(params => {
      let comparatorType = params['comparatorType'] ?? params['comparatorType'];
      if (comparatorType === "gas") {
        this.title = "Comparator oferte-tip de furnizare a gazelor naturale";
      } else if (comparatorType === "electric") {
        this.title = "Comparator oferte-tip de furnizare a energiei electrice";
      }
    });

  }

  ngOnInit(): void {
  }

}
